export default "__VITE_ASSET__AstEL015__"